goog.provide('el8.appanalytics.reportsMgr');

goog.require('el8.appanalytics.reports.bulkLetters');
goog.require('el8.appanalytics.reports.mu');
goog.require('el8.appanalytics.reports.muPopulation');
goog.require('el8.appanalytics.ReportTab');
goog.require('el8.util.base');

el8.appanalytics.reportsMgr = (function() {

    var _ReportTabsByName = {};

    return {

        showTab: function(name) {
            // Only can show 1 tab at a time
            for(var tab in _ReportTabsByName) {
                if (_ReportTabsByName.hasOwnProperty(tab)) {
                    if (tab !== name) {
                        _ReportTabsByName[tab].hide();
                    } else {
                        _ReportTabsByName[tab].show(true);
                    }
                }
            }
        },

        init: function(cqm_data) {

            if (el8Globals['FEATURES']['MUReports']) {
                _ReportTabsByName['mu'] =
                    el8.appanalytics.reports.mu.create();
            }

            // Fetch any custom quality measure groups.
            // components to the DOM
            var that = this;
            that.showTab('mu');
        }
    };

})();
